import {mapGetters} from 'vuex';
import {api} from "../../../global/framework/api.js";
import {formatter} from "../../../global/formatter.js";

export const searchCriteriaMixin = {
	data() {
		return {
			widgetReady: false,
			//Note: this will bind to the NEW search criteria, store will contain the CURRENT one
			searchCriteria: {
				radiusId: this.radiusId,
				addressId: 0,
				zipCode: '',
				latitude: 0,
				longitude: 0,
				designationId: null,
				onlyAcceptingNewPatients: true,
				physicianName: "",
				addressName: "",
				networkId: null,
				planCategoryId: null
			},
			hasSearchCriteria: false
		};
	},
	computed: {
		...mapGetters(["searchResults", "distance"]),
		...mapGetters({showInOfficePlans: 'globalSettings/showInOfficePlans', showVirtualPlans: 'globalSettings/showVirtualPlans'}),
	},
	methods: {
		async setCurrentCriteria() {
			//Read parameters from url if any
			this.searchCriteria.physicianName = this.$route.query.physicianName || '';
			this.searchCriteria.addressId = Boolean(this.$route.params.addressId) ? Number(this.$route.params.addressId) : 0;
			if (this.searchCriteria.addressId) {
				let addressView = await api.get('Address', this.searchCriteria.addressId, 'GetView');
				this.searchCriteria.addressName = formatter.formatAddress(addressView.address1,
					addressView.address2,
					addressView.city,
					addressView.stateCode,
					addressView.zipCode);
				this.searchCriteria.latitude = addressView.latitude;
				this.searchCriteria.longitude = addressView.longitude;
				this.hasSearchCriteria = true;
			} else if (Boolean(this.$route.params.latitude) && Boolean(this.$route.params.longitude)) {
				this.searchCriteria.addressName = this.$route.query.addressName || '';
				this.searchCriteria.latitude = this.$route.params.latitude;
				this.searchCriteria.longitude = this.$route.params.longitude;
				this.hasSearchCriteria = true;
			}
			if (!this.$route.params.radiusId) {
				if (this.showVirtualPlans) {
					this.searchCriteria.radiusId = 7;//Default value for virtual plans: Unlimited
				} else {
					this.searchCriteria.radiusId = 7;//Default value for in-office plans
				}
			} else {
				this.searchCriteria.radiusId = Number(this.$route.params.radiusId);
			}
			this.searchCriteria.designationId = this.$route.query.designationId || null;
			this.searchCriteria.onlyAcceptingNewPatients = typeof this.$route.query.onlyAcceptingNewPatients !== 'undefined' 
				? Boolean(Number(this.$route.query.onlyAcceptingNewPatients)) : true;
			const rawPlanCategoryId = this.$route.query.planCategoryId;
			this.searchCriteria.planCategoryId = typeof rawPlanCategoryId === 'undefined'
				|| rawPlanCategoryId === null
				|| rawPlanCategoryId === ''
				? null
				: Number(rawPlanCategoryId);
			this.searchCriteria.networkId = this.$route.query.networkId || null;},
		
		openFaqModal() {
			this.$refs.faqModal.showModal();
		}
	}
};